// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3hu1v","title":"Info_title__11D1r","selects":"Info_selects__1Z4p3","requiredAsterisk":"Info_requiredAsterisk__28PJQ"};